const link = process.env.REACT_APP_SERVER_API_V1

export const getCarLists = () => `${link}/vehicle/make-list`
